/**
 * PackBadge — inline provenance tag shown on recipe cards in Browse.
 * Shows a mini 2×2 swatch grid + "from {pack name}".
 */
export default function PackBadge({ pack, size = 10 }) {
  if (!pack) return null;
  const sizeClass = size === 10 ? ' rp-pack-badge--sm' : '';
  return (
    <span className={`rp-pack-badge${sizeClass}`}>
      <span className="rp-pack-badge-swatches--mini">
        {pack.swatches.slice(0, 4).map((s, i) => (
          <span key={i} className="rp-filter-swatch-cell" style={{ '--rp-swatch-bg': s }} />
        ))}
      </span>
      from <b className="rp-pack-badge-name">{pack.name}</b>
    </span>
  );
}
